import {Component, OnInit} from '@angular/core';
import {DatePipe} from '@angular/common';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {AppComponent} from './app.component';
import {DateAdapter, NativeDateAdapter} from '@angular/material';

import {AuthentificationService} from './authentification.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {InventoryService} from './inventory.service';
import {IMyDateModel} from 'mydatepicker';

@Component({
    selector: 'inventory-management',
    templateUrl: './templates/inventory-management.component.html',
    styleUrls: ['./styles/inventory-management.component.css'],
    providers: [DatePipe, AuthentificationService, InventoryService]
})
export class InventoryManagementComponent implements OnInit {

    showForm: boolean = true;

    inventory_form: FormGroup;

    date_debut: any;
    select_date: any;
    responsible_id: number = 0;
    responsible_name: string = "";
    reference: string = "";
    search_reference: string = "";
    team_member: string;
    inventory_name: string;
    date: any = '';
    stocktaking_list: Array<any> = [];
    id_stocktaking: any;

    constructor(
        private app_component: AppComponent,
        private fb: FormBuilder,
        private datePipe: DatePipe,
        private authentification_service: AuthentificationService,
        private router: Router,
        private inventory_service: InventoryService,
        private datepipe: DatePipe,
        private activate_route: ActivatedRoute,
        dateAdapter: DateAdapter<NativeDateAdapter>
    ) {
        this.app_component.valTest = '/inventories';
        this.app_component.GetParent();
        dateAdapter.setLocale('fr-FR');
        this.CheckUSerSession();
        this.GetStocktaking_cb();

    }

    GetStocktaking_cb(): void {
        this.activate_route.params.subscribe((params: Params) => {
            let id = params['id_stocktaking'];
            if (id !== undefined) {
                this.id_stocktaking = id;
            }
            this.GetList();
        });
    }

    createForm() {
        this.inventory_form = this.fb.group({
            //reference_ctl: ['', Validators.required],
            name_ctl: ['', Validators.required],
            date_ctl: [null, Validators.required],
            crew_ctl: ['', Validators.required]
        });
    }

    CheckUSerSession(): void {

        this.authentification_service.UserCheckSession().then(result => {
            if (result['id_user'] === 0) {
                this.router.navigate(['authentification'])
            } else {
                this.app_component.hide_wrapper(false);
                this.responsible_name = result['user_name'];
                this.responsible_id = result['id_user'];
            }
        });
    }

    onDateChanged(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date = "";
        } else {
            this.date = event.jsdate.toLocaleDateString("en-US");
        }
        this.GetList();
    }

    GetList(): void {
        /*let date;
        if(this.select_date !== undefined && this.select_date !== ""){
            date = this.datepipe.transform(this.select_date, 'dd/MM/yyyy');
        }else{
            this.select_date = "";
        }*/
        this.inventory_service.searchInventory(this.search_reference, this.date).then(result => {
            this.stocktaking_list = result['list'];
            for (let i = 0; i < this.stocktaking_list.length; i++) {
                if (parseInt(this.stocktaking_list[i].id_stocktaking) === parseInt(this.id_stocktaking)) {
                    //console.log(this.stocktaking_list[i]);
                    this.selected_tr = i;
                    //console.log(this.selected_tr);
                }
            }
        });
    }

    GetInventoryReference(): void {
        this.inventory_service.GetInventoryReference().then(result => {this.reference = result['reference']['reference_value'];});
    }


    validateButton() {
        if (this.inventory_form.status === "VALID") {
            this.inventory_service.Insert(this.reference, this.inventory_name, this.datepipe.transform(this.date_debut, 'yyyy-MM-dd'), this.responsible_id, this.team_member).then(result => {
                //redirectering to 'saisie'
                let id_stocktaking = result['result'];
                this.router.navigate(['inventory-capture', {id_stocktaking: id_stocktaking}]);
                this.Reset()
            });
        }
        // console.log(this.inventory_form.status);
    }

    show() {
        // console.log(this.date_debut);
    }

    Cancel() {
        this.Reset();
    }

    Reset(): void {
        this.inventory_form.reset();
        this.showForm = false;

        setTimeout(() => {

            this.createForm();
            this.showForm = true;
        });

    }

    Resume(id_stocktaking: any): void {

        this.router.navigate(['inventory-capture', {id_stocktaking: id_stocktaking}]);
    }
    
    Recount(id_stocktaking: any): void {

        this.router.navigate(['inventory-capture', {id_stocktaking: id_stocktaking}]);
    }
    
    Analyse(id_stocktaking: any): void {

       this.router.navigate(['inventory-analysis', {id_stocktaking: id_stocktaking}]);
    }

    SeeReport(id_stocktaking: any): void {
        //redirect to repport
    }

    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {

        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                'background-color': '#B3B6B7', //'#FFB400',
                //'color': 'orange',
            };
        }

        return styles;
    }

    ColorIndex(index: number) {
        //        console.log(index);
        //        console.log(this.selected_tr);
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {

                //'background-color': '#B3B6B7', //'#FFB400',
                'color': 'white',
            };
        }

        return styles;
    }

    suppr_img_src: string = "../../img/ico_supp.png";
    ImageDeleteSrcFile(index: number) {
        let suppr_img_src: string = "../../img/ico_supp.png";
        if (this.selected_tr === index) {
            suppr_img_src = "../../img/ico_supp_blanc.png";
        }

        return suppr_img_src;
    }
    ngOnInit() {
        this.createForm();
        this.GetInventoryReference();

        this.app_component.valTest = '/inventories';
        this.app_component.GetParent();
    }


}



// WEBPACK FOOTER //
// ./src/app/inventory-management.component.ts